import { render, staticRenderFns } from "./ProfileComponent.vue?vue&type=template&id=46d503eb&scoped=true"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileComponent.vue?vue&type=style&index=0&id=46d503eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d503eb",
  null
  
)

export default component.exports